import { useSelector } from "react-redux";
import { BookingStepper, BookingStepperProps } from "../BookingStepper/BookingStepper";
import { useBookingSteps } from "../../hooks/useBookingSteps";
import { BookingTunnel } from "../../constants/bookingSteps";

type BookingStepperContainerProps = {
	tunnel: BookingTunnel;
} & Omit<BookingStepperProps, "steps" | "value" | "clickable">;

type BrandState = { brand?: { clickableStepper?: boolean } };

/** Wires the tunnel's steps (labels + persisted urls + active step) to the presentational stepper. Steps are clickable only when the brand enables it via Sanity (`brand.clickableStepper`). */
export const BookingStepperContainer = ({ tunnel, ...props }: BookingStepperContainerProps) => {
	const { steps, value, clickable: clickableIfNotLastStep } = useBookingSteps({ tunnel });
	const clickableFromSanity = useSelector((state: BrandState) => state.brand?.clickableStepper);

	if (value < 0 || !steps.length) {
		return null;
	}

	const isClickable = Boolean(clickableIfNotLastStep && clickableFromSanity);

	return <BookingStepper {...props} steps={steps} value={value} clickable={isClickable} />;
};
